<script lang="ts" setup>
import { Cell, CellGroup, Popup } from "vant";
import { computed } from "vue";
import { useTask } from "@/stores/task";
import { clickBtn, getTaskAction } from "./Card/action";
import ActionBtn from "./Card/ActionBtn.vue";
import { storeToRefs } from "pinia";

const taskStore = useTask();
const { activeTaskId, selectedType, showMoreActionModal } =
  storeToRefs(taskStore);

const task = computed(() => taskStore.getTask(activeTaskId.value)!);
const tab = computed(() => task.value.tab);

const moreList = computed(() => {
  if (!task.value.entity) return [];
  const { isNsfw, isPaid } = task.value.entity as TextImage;
  const list = getTaskAction(activeTaskId.value, selectedType.value, 2);
  if (!isNsfw) return list;
  return list.filter(
    (v: string) => !["image", "brush", "gif", "emoji"].includes(v)
  );
});

// EventHandler
</script>
<template>
  <popup
    v-model:show="showMoreActionModal"
    class="py-4 flex flex-col gap-4"
    position="bottom"
    round
  >
    <cell-group inset>
      <cell
        v-for="item in moreList"
        :key="item"
        clickable
        @click="() => clickBtn(item, activeTaskId)"
      >
        <template #title>
          <ActionBtn
            :id="activeTaskId"
            :key="item + activeTaskId"
            :btn="item"
            extra-class="grid grid-cols-[32px_auto] pointer-events-none"
          />
        </template>
      </cell>
    </cell-group>
    <cell-group inset>
      <cell
        class="text-base-content/50"
        clickable
        :title="$t('Buttons.cancel')"
        @click="showMoreActionModal = false"
      />
    </cell-group>
  </popup>
</template>
